import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDk = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 370 280", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 370, height: 280, fill: "#c60c30" }), /* @__PURE__ */ React.createElement("rect", { width: 40, height: 280, x: 120, fill: "#fff" }), /* @__PURE__ */ React.createElement("rect", { width: 370, height: 40, y: 120, fill: "#fff" }));
const ForwardRef = forwardRef(SvgDk);
const Memo = memo(ForwardRef);
export default Memo;
